import { ParserFunctionType } from "../parser.type";
import { StoreData } from "../../../../models/store/store.data";
import { ParserAbstraction } from "@bitwarden/web-vault/app/services/dali/vault-parser/parser/parser.abstraction";

export class NoopParser extends ParserAbstraction {
  override getParser(version: number): ParserFunctionType {
    if (!this.isSupportedVersion(version)) {
      throw new Error(`Unsupported Noop parser version ${version}`);
    }
    return noopParser;
  }
  override getSupportedVersion(): number[] {
    return [0, 1];
  }
}

const noopParser = (obj: any): StoreData => obj as StoreData;
